import { track } from 'src/tracking/trackingService';

const EVENT_PREFIX = 'marketing.management.facebook_business_extension';

export const FacebookBusinessExtensionAnalytics = {
  trackReintegrateStepOne: () => {
    track(`${EVENT_PREFIX}.reintegrate_step_1.clicked`);
  },
  trackReintegrateStepTwo: () => {
    track(`${EVENT_PREFIX}.reintegrate_step_2.clicked`);
  },
  trackReintegrateStepThree: () => {
    track(`${EVENT_PREFIX}.reintegrate_step_3.clicked`);
  },
};
